module.exports = __webpack_public_path__ + "img/sb-ios-screen.40429bc5.png";